import { render, staticRenderFns } from "./Consolidado-anual.vue?vue&type=template&id=5c43ff5e"
import script from "./Consolidado-anual.vue?vue&type=script&lang=js"
export * from "./Consolidado-anual.vue?vue&type=script&lang=js"
import style0 from "./Consolidado-anual.vue?vue&type=style&index=0&id=5c43ff5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports